import * as Globalize from 'globalize';
var merge = function(obj1, obj2) {
  var obj3 = {};
  for(var attrname in obj1){obj3[attrname] = obj1[attrname]; }
  for(var attrname in obj2){obj3[attrname] = obj2[attrname]; }
  return obj3;
}
var dict = {
  "box user": "User",
  "filetype_box user": "User",
  "html": "HTML File",
  "filetype_html": "HTML File",
  "wiki": "Wiki",
  "filetype_wiki": "Wiki",
  "webscraperwebpage": "Web Page",
  "filetype_webscraperwebpage": "Web Page",
  "image": "Image",
  "filetype_image": "Image",
  "folder": "Folder",
  "filetype_folder": "Folder",
  "txt": "Text",
  "filetype_txt": "Text",
  "zip": "Zip File",
  "filetype_zip": "Zip File",
  "olefile": "OLE file",
  "filetype_olefile": "OLE file",
  "gmailmessage": "Gmail Message",
  "filetype_gmailmessage": "Gmail Message",
  "pdf": "PDF File",
  "filetype_pdf": "PDF File",
  "swf": "Flash File",
  "filetype_swf": "Flash File",
  "xml": "XML File",
  "filetype_xml": "XML File",
  "vsd": "Visio",
  "filetype_vsd": "Visio",
  "svg": "SVG",
  "filetype_svg": "SVG",
  "svm": "Open Office",
  "filetype_svm": "Open Office",
  "rssitem": "RSS feed",
  "filetype_rssitem": "RSS feed",
  "doc": "Document",
  "filetype_doc": "Document",
  "docx": "Microsoft Word Document",
  "filetype_docx": "Microsoft Word Document",
  "xls": "Spreadsheet Document",
  "filetype_xls": "Spreadsheet Document",
  "ppt": "Presentation Document",
  "filetype_ppt": "Presentation Document",
  "video": "Video",
  "filetype_video": "Video",
  "youtube": "YouTube video",
  "filetype_youtube": "YouTube video",
  "saleforceitem": "Salesforce",
  "filetype_saleforceitem": "Salesforce",
  "dynamicscrmitem": "Dynamics CRM",
  "filetype_dynamicscrmitem": "Dynamics CRM",
  "salesforceitem": "Salesforce",
  "filetype_salesforceitem": "Salesforce",
  "odt": "Open Text Document",
  "filetype_odt": "Open Text Document",
  "box": "User",
  "filetype_box": "User",
  "jiraissue": "Jira Issue",
  "filetype_jiraissue": "Jira Issue",
  "exchangemessage": "Message",
  "filetype_exchangemessage": "Message",
  "exchangeappointment": "Appointment",
  "filetype_exchangeappointment": "Appointment",
  "exchangenote": "Note",
  "filetype_exchangenote": "Note",
  "exchangetask": "Task",
  "filetype_exchangetask": "Task",
  "exchangeperson": "Exchange User",
  "filetype_exchangeperson": "Exchange User",
  "activedirperson": "Active Directory User",
  "filetype_activedirperson": "Active Directory User",
  "exchangeactivity": "Activity",
  "filetype_exchangeactivity": "Activity",
  "exchangecalendarmessage": "Calendar Message",
  "filetype_exchangecalendarmessage": "Calendar Message",
  "exchangedocument": "Exchange Document",
  "filetype_exchangedocument": "Exchange Document",
  "exchangedsn": "DSN",
  "filetype_exchangedsn": "DSN",
  "exchangefreebusy": "Free/Busy",
  "filetype_exchangefreebusy": "Free/Busy",
  "exchangegroup": "Group",
  "filetype_exchangegroup": "Group",
  "exchangerssfeed": "RSS Feed",
  "filetype_exchangerssfeed": "RSS Feed",
  "exchangejunkmessage": "Junk Email",
  "filetype_exchangejunkmessage": "Junk Email",
  "exchangeofficecom": "Communications",
  "filetype_exchangeofficecom": "Communications",
  "lithiummessage": "Lithium Message",
  "filetype_lithiummessage": "Lithium Message",
  "lithiumthread": "Lithium Thread",
  "filetype_lithiumthread": "Lithium Thread",
  "lithiumboard": "Lithium Board",
  "filetype_lithiumboard": "Lithium Board",
  "lithiumcategory": "Lithium Category",
  "filetype_lithiumcategory": "Lithium Category",
  "lithiumcommunity": "Lithium Community",
  "filetype_lithiumcommunity": "Lithium Community",
  "people": "User",
  "objecttype_people": "User",
  "message": "Message",
  "objecttype_message": "Message",
  "feed": "RSS Feed",
  "objecttype_feed": "RSS Feed",
  "thread": "Thread",
  "objecttype_thread": "Thread",
  "file": "File",
  "objecttype_file": "File",
  "board": "Board",
  "objecttype_board": "Board",
  "category": "Category",
  "objecttype_category": "Category",
  "account": "Account",
  "objecttype_account": "Account",
  "annotation": "Note",
  "objecttype_annotation": "Note",
  "campaign": "Campaign",
  "objecttype_campaign": "Campaign",
  "case": "Case",
  "objecttype_case": "Case",
  "contact": "Contact",
  "objecttype_contact": "Contact",
  "contract": "Contract",
  "objecttype_contract": "Contract",
  "event": "Event",
  "objecttype_event": "Event",
  "email": "Email",
  "objecttype_email": "Email",
  "goal": "Goal",
  "objecttype_goal": "Goal",
  "incident": "Incident",
  "objecttype_incident": "Incident",
  "invoice": "Invoice",
  "objecttype_invoice": "Invoice",
  "lead": "Lead",
  "objecttype_lead": "Lead",
  "list": "List",
  "objecttype_list": "Marketing List",
  "solution": "Solution",
  "objecttype_solution": "Solution",
  "report": "Report",
  "objecttype_report": "Report",
  "task": "Task",
  "objecttype_task": "Task",
  "user": "User",
  "objecttype_user": "User",
  "attachment": "Attachment",
  "objecttype_attachment": "Attachment",
  "casecomment": "Case Comment",
  "objecttype_casecomment": "Case Comment",
  "opportunity": "Opportunity",
  "objecttype_opportunity": "Opportunity",
  "opportunityproduct": "Opportunity Product",
  "objecttype_opportunityproduct": "Opportunity Product",
  "feeditem": "Chatter",
  "objecttype_feeditem": "Chatter",
  "feedcomment": "Comment",
  "objecttype_feedcomment": "Comment",
  "note": "Note",
  "objecttype_note": "Note",
  "product": "Product",
  "objecttype_product": "Product",
  "partner": "Partner",
  "objecttype_partner": "Partner",
  "queueitem": "Queue Item",
  "objecttype_queueitem": "Queue Item",
  "quote": "Quote",
  "objecttype_quote": "Quote",
  "salesliterature": "Sales Literature",
  "objecttype_salesliterature": "Sales Literature",
  "salesorder": "Sales Order",
  "objecttype_salesorder": "Sales Order",
  "service": "Service",
  "objecttype_service": "Service",
  "socialprofile": "Social Profile",
  "objecttype_socialprofile": "Social Profile",
  "kbdocumentation": "Knowledge Document",
  "objecttype_kbdocumentation": "Knowledge Document",
  "kbtechnicalarticle": "Technical Documentation",
  "objecttype_kbtechnicalarticle": "Technical Documentation",
  "kbsolution": "Solution",
  "objecttype_kbsolution": "Solution",
  "kbknowledgearticle": "Knowledge Article",
  "objecttype_kbknowledgearticle": "Knowledge Article",
  "kbattachment": "Attachment",
  "objecttype_kbattachment": "Attachment",
  "kbarticle": "Article",
  "objecttype_kbarticle": "Article",
  "kbarticlecomment": "Article Comment",
  "objecttype_kbarticlecomment": "Article Comment",
  "knowledgearticle": "Knowledge Article",
  "objecttype_knowledgearticle": "Knowledge Article",
  "topic": "Topic",
  "objecttype_topic": "Topic",
  "dashboard": "Dashboard",
  "objecttype_dashboard": "Dashboard",
  "contentversion": "Document",
  "objecttype_contentversion": "Document",
  "collaborationgroup": "Collaboration group",
  "objecttype_collaborationgroup": "Collaboration group",
  "phonecall": "Phone call",
  "objecttype_phonecall": "Phone call",
  "appointment": "Appointment",
  "objecttype_appointment": "Appointment",
  "cfpage": "Confluence Page",
  "filetype_cfpage": "Confluence Page",
  "cfcomment": "Confluence Comment",
  "filetype_cfcomment": "Confluence Comment",
  "cfspace": "Confluence Space",
  "filetype_cfspace": "Confluence Space",
  "cfblogentry": "Confluence Blog Entry",
  "filetype_cfblogentry": "Confluence Blog Entry",
  "confluencespace": "Confluence Space",
  "filetype_confluencespace": "Confluence Space",
  "sn_hr_core_case": "HR Case",
  "filetype_sn_hr_core_case": "HR Case",
  "sc_cat_item": "Catalog Item",
  "filetype_sc_cat_item": "Catalog Item",
  "sn_customerservice_case": "Case",
  "filetype_sn_customerservice_case": "Case",
  "kb_social_qa_answer": "Answer",
  "filetype_kb_social_qa_answer": "Answer",
  "kb_social_qa_question": "Question",
  "filetype_kb_social_qa_question": "Question",
  "kb_social_qa_comment": "Comment",
  "filetype_kb_social_qa_comment": "Comment",
  "filetype_incident": "Incident",
  "kb_knowledge": "Knowledge Article",
  "filetype_kb_knowledge": "Knowledge Article",
  "spportal": "Portal",
  "filetype_spportal": "Portal",
  "spsite": "SharePoint Site",
  "filetype_spsite": "SharePoint Site",
  "spuserprofile": "SharePoint User",
  "filetype_spuserprofile": "SharePoint User",
  "sparea": "Area",
  "filetype_sparea": "Area",
  "spannouncement": "Announcement",
  "filetype_spannouncement": "Announcement",
  "spannouncementlist": "Announcements",
  "filetype_spannouncementlist": "Announcements",
  "spcontact": "Contact",
  "filetype_spcontact": "Contact",
  "spcontactlist": "Contacts",
  "filetype_spcontactlist": "Contacts",
  "spcustomlist": "Custom Lists",
  "filetype_spcustomlist": "Custom Lists",
  "spdiscussionboard": "Discussion Board",
  "filetype_spdiscussionboard": "Discussion Board",
  "spdiscussionboardlist": "Discussion Boards",
  "filetype_spdiscussionboardlist": "Discussion Boards",
  "spdocumentlibrarylist": "Document Library",
  "filetype_spdocumentlibrarylist": "Document Library",
  "spevent": "Event",
  "filetype_spevent": "Event",
  "speventlist": "Events",
  "filetype_speventlist": "Events",
  "spformlibrarylist": "Form Library",
  "filetype_spformlibrarylist": "Form Library",
  "spissue": "Issue",
  "filetype_spissue": "Issue",
  "spissuelist": "Issues",
  "filetype_spissuelist": "Issues",
  "splink": "Link",
  "filetype_splink": "Link",
  "splinklist": "Links",
  "filetype_splinklist": "Links",
  "sppicturelibrarylist": "Picture Library",
  "filetype_sppicturelibrarylist": "Picture Library",
  "spsurvey": "Survey",
  "filetype_spsurvey": "Survey",
  "spsurveylist": "Surveys",
  "filetype_spsurveylist": "Surveys",
  "sptask": "Task",
  "filetype_sptask": "Task",
  "sptasklist": "Tasks",
  "filetype_sptasklist": "Tasks",
  "spagenda": "Agenda",
  "filetype_spagenda": "Agenda",
  "spagendalist": "Agendas",
  "filetype_spagendalist": "Agendas",
  "spattendee": "Attendee",
  "filetype_spattendee": "Attendee",
  "spattendeelist": "Attendees",
  "filetype_spattendeelist": "Attendees",
  "spcustomgridlist": "Custom Grids",
  "filetype_spcustomgridlist": "Custom Grids",
  "spdecision": "Decision",
  "filetype_spdecision": "Decision",
  "spdecisionlist": "Decisions",
  "filetype_spdecisionlist": "Decisions",
  "spobjective": "Objective",
  "filetype_spobjective": "Objective",
  "spobjectivelist": "Objectives",
  "filetype_spobjectivelist": "Objectives",
  "sptextbox": "Textbox",
  "filetype_sptextbox": "Textbox",
  "sptextboxlist": "Textbox list",
  "filetype_sptextboxlist": "Textbox list",
  "spthingstobring": "Thing To Bring",
  "filetype_spthingstobring": "Thing To Bring",
  "spthingstobringlist": "Things To Bring",
  "filetype_spthingstobringlist": "Things To Bring",
  "sparealisting": "Area Listing",
  "filetype_sparealisting": "Area Listing",
  "spmeetingserie": "Meeting series",
  "filetype_spmeetingserie": "Meeting series",
  "spmeetingserielist": "Meeting Series List",
  "filetype_spmeetingserielist": "Meeting Series List",
  "spsitedirectory": "Site Directory Item",
  "filetype_spsitedirectory": "Site Directory Item",
  "spsitedirectorylist": "Site Directory",
  "filetype_spsitedirectorylist": "Site Directory",
  "spdatasource": "Data Source",
  "filetype_spdatasource": "Data Source",
  "spdatasourcelist": "Data Source List",
  "filetype_spdatasourcelist": "Data Source List",
  "splisttemplatecataloglist": "List Template Gallery",
  "filetype_splisttemplatecataloglist": "List Template Gallery",
  "spwebpartcataloglist": "WebPart Gallery",
  "filetype_spwebpartcataloglist": "WebPart Gallery",
  "spwebtemplatecataloglist": "Site Template Gallery",
  "filetype_spwebtemplatecataloglist": "Site Template Gallery",
  "spworkspacepagelist": "Workspace Pages",
  "filetype_spworkspacepagelist": "Workspace Pages",
  "spunknownlist": "Custom List",
  "filetype_spunknownlist": "Custom List",
  "spadministratortask": "Administrator Task",
  "filetype_spadministratortask": "Administrator Task",
  "spadministratortasklist": "Administrator Tasks",
  "filetype_spadministratortasklist": "Administrator Tasks",
  "spareadocumentlibrarylist": "Area Document Library",
  "filetype_spareadocumentlibrarylist": "Area Document Library",
  "spblogcategory": "Blog Category",
  "filetype_spblogcategory": "Blog Category",
  "spblogcategorylist": "Blog Categories",
  "filetype_spblogcategorylist": "Blog Categories",
  "spblogcomment": "Blog Comment",
  "filetype_spblogcomment": "Blog Comment",
  "spblogcommentlist": "Blog Comments",
  "filetype_spblogcommentlist": "Blog Comments",
  "spblogpost": "Blog Post",
  "filetype_spblogpost": "Blog Post",
  "spblogpostlist": "Blog Posts",
  "filetype_spblogpostlist": "Blog Posts",
  "spdataconnectionlibrarylist": "Data Connection Library",
  "filetype_spdataconnectionlibrarylist": "Data Connection Library",
  "spdistributiongroup": "Distribution Group",
  "filetype_spdistributiongroup": "Distribution Group",
  "spdistributiongrouplist": "Distribution Groups",
  "filetype_spdistributiongrouplist": "Distribution Groups",
  "spipfslist": "InfoPath Forms Servers",
  "filetype_spipfslist": "InfoPath Forms Servers",
  "spkeyperformanceindicator": "Key Performance Indicator",
  "filetype_spkeyperformanceindicator": "Key Performance Indicator",
  "spkeyperformanceindicatorlist": "Key Performance Indicators",
  "filetype_spkeyperformanceindicatorlist": "Key Performance Indicators",
  "splanguagesandtranslator": "Languages and Translator",
  "filetype_splanguagesandtranslator": "Languages and Translator",
  "splanguagesandtranslatorlist": "Languages and Translators",
  "filetype_splanguagesandtranslatorlist": "Languages and Translators",
  "spmasterpagescataloglist": "Master Page Gallery",
  "filetype_spmasterpagescataloglist": "Master Page Gallery",
  "spnocodeworkflowlibrarylist": "No-code Workflow Libraries",
  "filetype_spnocodeworkflowlibrarylist": "No-code Workflow Libraries",
  "spprojecttask": "Project Task",
  "filetype_spprojecttask": "Project Task",
  "spprojecttasklist": "Project Tasks",
  "filetype_spprojecttasklist": "Project Tasks",
  "sppublishingpageslibrarylist": "Page Library",
  "filetype_sppublishingpageslibrarylist": "Page Library",
  "spreportdocumentlibrarylist": "Report Document Library",
  "filetype_spreportdocumentlibrarylist": "Report Document Library",
  "spreportlibrarylist": "Report Library",
  "filetype_spreportlibrarylist": "Report Library",
  "spslidelibrarylist": "Slide Library",
  "filetype_spslidelibrarylist": "Slide Library",
  "sptab": "Tabs",
  "filetype_sptab": "Tabs",
  "sptablist": "Tabs List",
  "filetype_sptablist": "Tabs List",
  "sptranslationmanagementlibrarylist": "Translation Management Library",
  "filetype_sptranslationmanagementlibrarylist": "Translation Management Library",
  "spuserinformation": "User Information",
  "filetype_spuserinformation": "User Information",
  "spuserinformationlist": "User Information List",
  "filetype_spuserinformationlist": "User Information List",
  "spwikipagelibrarylist": "Wiki Page Library",
  "filetype_spwikipagelibrarylist": "Wiki Page Library",
  "spworkflowhistory": "Workflow History",
  "filetype_spworkflowhistory": "Workflow History",
  "spworkflowhistorylist": "Workflow History List",
  "filetype_spworkflowhistorylist": "Workflow History List",
  "spworkflowprocess": "Custom Workflow Process",
  "filetype_spworkflowprocess": "Custom Workflow Process",
  "spworkflowprocesslist": "Custom Workflow Processes",
  "filetype_spworkflowprocesslist": "Custom Workflow Processes",
  "sppublishingimageslibrarylist": "Publishing Image Library",
  "filetype_sppublishingimageslibrarylist": "Publishing Image Library",
  "spcirculation": "Circulation",
  "filetype_spcirculation": "Circulation",
  "spcirculationlist": "Circulations",
  "filetype_spcirculationlist": "Circulations",
  "spdashboardslibrarylist": "Dashboards Library",
  "filetype_spdashboardslibrarylist": "Dashboards Library",
  "spdataconnectionforperformancepointlibrarylist": "PerformancePoint Data Connection Library",
  "filetype_spdataconnectionforperformancepointlibrarylist": "PerformancePoint Data Connection Library",
  "sphealthreport": "Health Report",
  "filetype_sphealthreport": "Health Report",
  "sphealthreportlist": "Health Reports",
  "filetype_sphealthreportlist": "Health Reports",
  "sphealthrule": "Health Rule",
  "filetype_sphealthrule": "Health Rule",
  "sphealthrulelist": "Health Rules",
  "filetype_sphealthrulelist": "Health Rules",
  "spimedictionary": "IME Dictionary",
  "filetype_spimedictionary": "IME Dictionary",
  "spimedictionarylist": "IME Dictionaries",
  "filetype_spimedictionarylist": "IME Dictionaries",
  "spperformancepointcontent": "PerformancePoint Content",
  "filetype_spperformancepointcontent": "PerformancePoint Content",
  "spperformancepointcontentlist": "PerformancePoint Contents",
  "filetype_spperformancepointcontentlist": "PerformancePoint Contents",
  "spphonecallmemo": "Phone Call Memo",
  "filetype_spphonecallmemo": "Phone Call Memo",
  "spphonecallmemolist": "Phone Call Memos",
  "filetype_spphonecallmemolist": "Phone Call Memos",
  "sprecordlibrarylist": "Record Library",
  "filetype_sprecordlibrarylist": "Record Library",
  "spresource": "Resource",
  "filetype_spresource": "Resource",
  "spresourcelist": "Resources",
  "filetype_spresourcelist": "Resources",
  "spprocessdiagramslibrarylist": "Process Diagram Library",
  "filetype_spprocessdiagramslibrarylist": "Process Diagram Library",
  "spsitethemeslibrarylist": "Site Theme Library",
  "filetype_spsitethemeslibrarylist": "Site Theme Library",
  "spsolutionslibrarylist": "Solution Library",
  "filetype_spsolutionslibrarylist": "Solution Library",
  "spwfpublibrarylist": "WFPUB Library",
  "filetype_spwfpublibrarylist": "WFPUB Library",
  "spwhereabout": "Whereabout",
  "filetype_spwhereabout": "Whereabout",
  "spwhereaboutlist": "Whereabouts",
  "filetype_spwhereaboutlist": "Whereabouts",
  "spdocumentlink": "Link to a Document",
  "filetype_spdocumentlink": "Link to a Document",
  "spdocumentset": "Document Set",
  "filetype_spdocumentset": "Document Set",
  "spmicrofeedpost": "Microfeed Post",
  "filetype_spmicrofeedpost": "Microfeed Post",
  "spmicrofeedlist": "Microfeed",
  "filetype_spmicrofeedlist": "Microfeed",
  "splistfolder": "List Folder",
  "filetype_splistfolder": "List Folder",
  "slackmessage": "Slack Message",
  "filetype_slackmessage": "Slack Message",
  "slackchannel": "Slack Channel",
  "filetype_slackchannel": "Slack Channel",
  "slackfile": "Slack File",
  "filetype_slackfile": "Slack File",
  "slackuser": "Slack User",
  "filetype_slackuser": "Slack User",
  "youtubevideo": "YouTube video",
  "filetype_youtubevideo": "YouTube video",
  "youtubeplaylistitem": "YouTube playlist item",
  "filetype_youtubeplaylistitem": "YouTube playlist item",
  "youtubeplaylist": "YouTube playlist",
  "filetype_youtubeplaylist": "YouTube playlist",
  "Unknown": "Unknown",
  "And": "AND",
  "Authenticating": "Authenticating {0}...",
  "Clear": "Clear {0}",
  "CompleteQuery": "Complete query",
  "Exclude": "Exclude {0}",
  "EnterTag": "Add Tag",
  "Next": "Next",
  "Last": "Last",
  "Link": "Link",
  "Or": "OR",
  "Previous": "Previous",
  "QueryDidntMatchAnyDocuments": "Your query did not match any documents.",
  "QueryException": "Your query has an error: {0}.",
  "Me": "Me",
  "Remove": "Remove",
  "Search": "Search",
  "SearchFor": "Search for {0}",
  "SubmitSearch": "Submit search",
  "ShareQuery": "Share Query",
  "Preferences": "Preferences",
  "LinkOpeningSettings": "Link opening settings",
  "Reauthenticate": "Reauthenticate {0}",
  "ResultsFilteringExpression": "Result filtering expressions",
  "FiltersInYourPreferences": "Filters in your preferences",
  "Create": "Create",
  "SearchIn": "Search in {0}",
  "Seconds": "in {0} second<pl>s</pl>",
  "ShowingResultsOf": "Result<pl>s</pl> {0}<pl>-{1}</pl> of {2}",
  "ShowingResultsOfWithQuery": "Result<pl>s</pl> {0}<pl>-{1}</pl> of {2} for {3}",
  "SwitchTo": "Switch to {0}",
  "Unexclude": "Remove exclusion filter on {0}",
  "ClearAllFilters": "Clear All Filters",
  "SkipLogin": "Skip login",
  "LoginInProgress": "Login in progress, please wait ...",
  "Login": "Log In",
  "GetStarted": "Get Started",
  "More": "More",
  "NMore": "{0} more...",
  "Less": "Fewer",
  "Settings": "Settings",
  "Score": "Score",
  "ScoreDescription": "The score is computed from the number of occurrences as well as from the position in the result set.",
  "Occurrences": "Occurrences",
  "OccurrencesDescription": "Sort by number of occurrences, with values having the highest number appearing first.",
  "Label": "Label",
  "Of": "of",
  "LabelDescription": "Sort alphabetically on the field values.",
  "Value": "Value",
  "ValueDescription": "Sort on the values of the first computed field",
  "AlphaAscending": "Value Ascending",
  "AlphaDescending": "Value Descending",
  "ChiSquare": "Chi Square",
  "Nosort": "No Sort",
  "NosortDescription": "Do not sort the values. The values will be returned in a random order.",
  "RelativeFrequency": "Relative Frequency",
  "RelativeFrequencyDescription": "Sort based on the relative frequency of values. Less common values will appear higher.",
  "DateDistribution": "Date distribution",
  "Custom": "Custom",
  "CustomDescription": "Sort based on a custom order",
  "ComputedField": "Computed Field",
  "Ascending": "Ascending",
  "Descending": "Descending",
  "noResultFor": "No results for {0}",
  "noResult": "No results",
  "autoCorrectedQueryTo": "Query was automatically corrected to {0}",
  "didYouMean": "Did you mean: {0}",
  "SuggestedResults": "Suggested Results",
  "SuggestedQueries": "Suggested Queries",
  "MostRelevantItems": "Most relevant items:",
  "AllItems": "All items:",
  "ShowLess": "Show less",
  "ShowMore": "Show more",
  "HideFacet": "Hide Facet",
  "ShowFacet": "Show Facet",
  "AndOthers": "and {0} other<pl>s</pl>",
  "Others": "{0} other<pl>s</pl>",
  "MostRelevantPosts": "Most Relevant Posts:",
  "CompleteThread": "Complete Thread:",
  "ShowCompleteThread": "Show Complete Thread",
  "ShowOnlyTopMatchingPosts": "Show Only Top Matching Posts",
  "MostRelevantReplies": "Most Relevant Replies:",
  "AllConversation": "All Conversation:",
  "ShowAllConversation": "Show All Conversation",
  "ShowAllReplies": "Show All Replies",
  "ShowOnlyMostRelevantReplies": "Show Only Most Relevant Replies",
  "Close": "Close",
  "Open": "Open",
  "OpenInOutlookWhenPossible": "Open in Outlook (when possible)",
  "AlwaysOpenInNewWindow": "Always open results in new window",
  "Quickview": "Quick View",
  "NoQuickview": "The Quick View for this document is unavailable",
  "ErrorReport": "Error Report",
  "OopsError": "Something went wrong.",
  "ProblemPersists": "If the problem persists contact the administrator.",
  "GoBack": "Go Back",
  "Reset": "Reset",
  "Retry": "Retry",
  "MoreInfo": "More Information",
  "Username": "Username",
  "Password": "Password",
  "PostedBy": "Posted by",
  "CannotConnect": "Cannot connect to the server address.",
  "BadUserPass": "Password does not match with username.",
  "PleaseEnterYourCredentials": "Please enter your credentials for {0}.",
  "PleaseEnterYourSearchPage": "Please enter your search page URL",
  "Collapse": "Collapse",
  "Collapsable": "Collapsible",
  "Expand": "Expand",
  "CollapseFacet": "Collapse {0} facet",
  "ExpandFacet": "Expand {0} facet",
  "ShowLessFacetResults": "Show fewer results for {0} facet",
  "ShowMoreFacetResults": "Show more results for {0} facet",
  "ShowLessCategoryResults": "Show fewer results for the {0} category",
  "ShowMoreCategoryResults": "Show more results for the {0} category",
  "ShowLessHierarchicalResults": "Show fewer results for the {0} facet",
  "ShowMoreHierarchicalResults": "Show more results for the {0} facet",
  "SearchFacetResults": "Search for values in {0} facet",
  "Today": "Today",
  "Yesterday": "Yesterday",
  "Tomorrow": "Tomorrow",
  "Duration": "Duration: {0}",
  "IndexDuration": "Index Duration: {0}",
  "ProxyDuration": "Proxy Duration: {0}",
  "ClientDuration": "Client Duration: {0}",
  "Unavailable": "Unavailable",
  "Reply": "Reply",
  "ReplyAll": "Reply All",
  "Forward": "Forward",
  "From": "From",
  "Caption": "Caption",
  "Expression": "Expression",
  "Tab": "Tab",
  "Tabs": "Tabs",
  "EnterExpressionName": "Enter expression name",
  "EnterExpressionToFilterWith": "Enter expression to filter results with",
  "SelectTab": "Select Tab",
  "SelectAll": "Select All",
  "PageUrl": "Search page URL",
  "ErrorSavingToDevice": "Error while saving the information to your device",
  "ErrorReadingFromDevice": "Error while reading the information from your device",
  "AppIntro": "Speak with a product specialist who can answer your questions about Coveo and help you decide which Coveo solution is right for you. Or, try a live demo !",
  "TryDemo": "Try the demo",
  "ContactUs": "Contact us",
  "NewToCoveo": "New to Coveo?",
  "LetUsHelpGetStarted": "Let us help you get started",
  "LikesThis": "{0} like<sn>s</sn> this.",
  "CannotConnectSearchPage": "Cannot connect to your search page",
  "AreYouSureDeleteFilter": "Are you sure you want to delete the filter {0} with the expression {1}",
  "OnlineHelp": "Online Help",
  "Done": "Done",
  "SaveFacetState": "Save this facet state",
  "ClearFacetState": "Clear facet state",
  "DisplayingTheOnlyMessage": "Displaying the only message in this conversation",
  "NoNetworkConnection": "No network connection",
  "UnknownConnection": "Unknown connection",
  "EthernetConnection": "Ethernet connection",
  "WiFi": "WiFi connection",
  "CELL": "Cellular connection",
  "CELL_2G": "Cellular 2G connection",
  "CELL_3G": "Cellular 3G connection",
  "CELL_4G": "Cellular 4G connection",
  "Relevance": "Relevance",
  "Date": "Date",
  "Amount": "Amount",
  "QueryExceptionNoException": "No exception",
  "QueryExceptionInvalidSyntax": "Invalid syntax",
  "QueryExceptionInvalidCustomField": "Invalid custom field",
  "QueryExceptionInvalidDate": "Invalid date",
  "QueryExceptionInvalidExactPhrase": "Invalid exact phrase",
  "QueryExceptionInvalidDateOp": "Invalid date operator",
  "QueryExceptionInvalidNear": "Invalid NEAR operator",
  "QueryExceptionInvalidWeightedNear": "Invalid weighted NEAR",
  "QueryExceptionInvalidTerm": "Invalid term",
  "QueryExceptionTooManyTerms": "Too many terms",
  "QueryExceptionWildcardTooGeneral": "Wildcard too general",
  "QueryExceptionInvalidSortField": "Invalid sort field",
  "QueryExceptionInvalidSmallStringOp": "Invalid small string operator",
  "QueryExceptionRequestedResultsMax": "Requested results maximum",
  "QueryExceptionAggregatedMirrorDead": "Aggregated mirror is offline",
  "QueryExceptionAggregatedMirrorQueryTimeOut": "Aggregated mirror query timeout",
  "QueryExceptionAggregatedMirrorInvalidBuildNumber": "Aggregated mirror invalid build number",
  "QueryExceptionAggregatedMirrorCannotConnect": "Aggregated mirror cannot connect",
  "QueryExceptionNotEnoughLeadingCharsWildcard": "Not enough leading character wildcard",
  "QueryExceptionSecurityInverterNotFound": "Security inverter not found",
  "QueryExceptionSecurityInverterAccessDenied": "Security inverter access denied",
  "QueryExceptionAggregatedMirrorCannotImpersonate": "Aggregated mirror cannot impersonate",
  "QueryExceptionUnexpected": "Unexpected",
  "QueryExceptionAccessDenied": "Access denied",
  "QueryExceptionSuperUserTokenInvalid": "Super user token invalid",
  "QueryExceptionSuperUserTokenExpired": "Super user token is expired",
  "QueryExceptionLicenseQueriesExpired": "Queries license expired",
  "QueryExceptionLicenseSuperUserTokenNotSupported": "License super user token not supported",
  "QueryExceptionInvalidSession": "Invalid session",
  "QueryExceptionInvalidDocument": "Invalid document",
  "QueryExceptionSearchDisabled": "Search disabled",
  "FileType": "File type",
  "ShowAttachment": "Show attachment",
  "OnFeed": "on {0}'s feed.",
  "Author": "Author",
  "NoTitle": "No title",
  "CurrentSelections": "Current selections",
  "AllContent": "All content",
  "CancelLastAction": "Cancel last action",
  "SearchTips": "Search tips",
  "CheckSpelling": "Check the spelling of your keywords.",
  "TryUsingFewerKeywords": "Try using fewer, different or more general keywords.",
  "SelectFewerFilters": "Select fewer filters to broaden your search.",
  "Document": "Document",
  "Time": "Time",
  "StartDate": "Start Date",
  "StartTime": "Start Time",
  "DurationTitle": "Duration",
  "UserQuery": "User query",
  "ShowUserActions": "Show User Actions",
  "NoData": "No data available",
  "EventType": "Event type",
  "GoToFullSearch": "Full search",
  "GoToEdition": "Customize Panel",
  "RemoveContext": "Remove context",
  "BoxAttachToCase": "Attach to case",
  "AttachToCase": "Attach to case",
  "Attach": "Attach",
  "Attached": "Attached",
  "Detach": "Detach",
  "Details": "Details",
  "AdditionalFilters": "Additional filters",
  "SelectNonContextualSearch": "Remove the context from the current record to broaden your search",
  "CopyPasteToSupport": "Copy paste this message to the Coveo Support team for more information.",
  "FollowQueryDescription": "Alert me for changes to the search results of this query.",
  "SearchAlerts_Panel": "Manage Alerts",
  "SearchAlerts_PanelDescription": "View and manage your search alerts.",
  "SearchAlerts_PanelNoSearchAlerts": "You have no subscriptions.",
  "SearchAlerts_Fail": "The Search Alerts service is currently unavailable.",
  "SearchAlerts_Type": "Type",
  "SearchAlerts_Content": "Content",
  "SearchAlerts_Actions": "Action",
  "EmptyQuery": "<empty>",
  "SearchAlerts_Type_followQuery": "Query",
  "SearchAlerts_Type_followDocument": "Item",
  "SearchAlerts_unFollowing": "Stop Following",
  "SearchAlerts_follow": "Follow",
  "SearchAlerts_followed": "Followed",
  "SearchAlerts_followQuery": "Follow Query",
  "Subscription_StopFollowingQuery": "Stop Following Query",
  "SearchAlerts_Frequency": "When",
  "SubscriptionsManageSubscriptions": "Manage Alerts",
  "SubscriptionsMessageFollowQuery": "You will receive alerts when the query <b>{0}</b> returns new or updated items.",
  "SubscriptionsMessageFollow": "You will receive alerts for changes to the item <b>{0}</b>.",
  "Expiration": "Expiration",
  "Monthly": "Monthly",
  "Daily": "Daily",
  "Monday": "Monday",
  "Tuesday": "Tuesday",
  "Wednesday": "Wednesday",
  "Thursday": "Thursday",
  "Friday": "Friday",
  "Saturday": "Saturday",
  "Sunday": "Sunday",
  "NextDay": "Next {0}",
  "LastDay": "Last {0}",
  "StartTypingCaseForSuggestions": "Describe your problem to see possible solutions",
  "ExportToExcel": "Export to Excel",
  "ExportToExcelDescription": "Export search results to Excel",
  "CaseCreationNoResults": "No recommended solutions were found",
  "SortBy": "Sort by",
  "BoxCreateArticle": "Create Article",
  "Facets": "Facets",
  "AdvancedSearch": "Advanced Search",
  "Keywords": "Keywords",
  "AllTheseWords": "All these words",
  "ExactPhrase": "This exact phrase",
  "AnyOfTheseWords": "Any of these words",
  "NoneOfTheseWords": "None of these words",
  "Anytime": "Anytime",
  "InTheLast": "In the last",
  "Days": "days",
  "Months": "months",
  "Month": "Month",
  "Year": "Year",
  "Between": "Between",
  "Language": "Language",
  "Size": "Size",
  "AtLeast": "at least",
  "AtMost": "at most",
  "Contains": "contains",
  "DoesNotContain": "does not contain",
  "Matches": "matches",
  "Bytes": "bytes",
  "card": "Card",
  "table": "Table",
  "ResultLinks": "Result links",
  "EnableQuerySyntax": "Enable query syntax",
  "On": "On",
  "Off": "Off",
  "Automatic": "Automatic",
  "ResultsPerPage": "Results per page",
  "PreviousMonth": "Previous month",
  "NextMonth": "Next month",
  "Title": "Title",
  "FiltersInAdvancedSearch": "Filters in Advanced Search",
  "NoEndpoints": "{0} has no registered endpoints.",
  "InvalidToken": "The token used is invalid.",
  "AddSources": "You will need to add sources in your index, or wait for the created sources to finish indexing.",
  "TryAgain": "Please try again.",
  "CoveoOnlineHelp": "Coveo Online Help",
  "CannotAccess": "{0} cannot be accessed.",
  "CoveoOrganization": "Coveo Organization",
  "SearchAPIDuration": "Search API Duration: {0}",
  "LastUpdated": "Last updated",
  "AllDates": "All dates",
  "WithinLastDay": "Within last day",
  "WithinLastWeek": "Within last week",
  "WithinLastMonth": "Within last month",
  "WithinLastYear": "Within last year",
  "RelevanceInspector": "Relevance Inspector",
  "KeywordInCategory": "{0} <span class=\"coveo-omnibox-suggestion-category\">in {1}</span>",
  "Result": "Result",
  "ResultCount": "{0} result<pl>s</pl>",
  "ShowingResults": "{0} result<pl>s</pl>",
  "ShowingResultsWithQuery": "{0} result<pl>s</pl> for {1}",
  "NumberOfVideos": "Number of videos",
  "AllCategories": "All Categories",
  "Recommended": "Recommended",
  "Featured": "Featured",
  "CoveoHomePage": "Coveo Home page",
  "SizeValue": "Size value",
  "UnitMeasurement": "Unit of measurement",
  "Toggle": "Toggle",
  "FilterOn": "Filter on {0}",
  "RemoveFilterOn": "Remove inclusion filter on {0}",
  "Enter": "Enter",
  "InsertAQuery": "Insert a query",
  "PressEnterToSend": "Press enter to send",
  "SortResultsBy": "Sort results by {0}",
  "SortResultsByAscending": "Sort by {0} in ascending order",
  "SortResultsByDescending": "Sort by {0} in descending order",
  "DisplayResultsAs": "Display results as {0}",
  "FacetTitle": "{0} facet",
  "IncludeValueWithResultCount": "Inclusion filter on {0}; {1}",
  "ExcludeValueWithResultCount": "Exclusion filter on {0}; {1}",
  "PageNumber": "Page {0}",
  "DisplayResultsPerPage": "Display {0} results per page",
  "GroupByAndFacetRequestsCannotCoexist": "The query is invalid because it contains both Group By and Facet requests. Ensure that the search interface does not initialize DynamicFacet components alongside Facet components (or alongside any component extending the Facet component, such as FacetRange or FacetSlider).",
  "MustContain": "Must contain:",
  "Missing": "Missing:",
  "Filters": "Filters",
  "FiltersDropdown": "Filters dropdown",
  "OpenFiltersDropdown": "Open the filters dropdown",
  "CloseFiltersDropdown": "Close the filters dropdown",
  "NoValuesFound": "No values found.",
  "To": "to",
  "DeselectFilterValues": "Deselect all active filters on {0} field",
  "Rated": "Rated {0} out of {1} star<pl>s</pl>",
  "RatedBy": "by {0} user<pl>s</pl>",
  "NoRatings": "No ratings",
  "Pagination": "Pagination",
  "ThumbnailOf": "Thumbnail of \"{0}\"",
  "CollapsedUriParts": "Collapsed URI parts",
  "HierarchicalFacetValueIndentedUnder": "{0} under {1}",
  "HierarchicalFacetValuePathPrefix": "in",
  "UsefulnessFeedbackRequest": "Was this useful?",
  "UsefulnessFeedbackThankYou": "Thanks for your feedback!",
  "UsefulnessFeedbackExplainWhy": "Explain why",
  "UsefulnessFeedbackExplainWhyImperative": "Explain why",
  "UsefulnessFeedbackDoesNotAnswer": "This didn't answer my question at all",
  "UsefulnessFeedbackPartiallyAnswers": "This only partially answered my question",
  "UsefulnessFeedbackWasNotAQuestion": "My request wasn't meant to be perceived as a question",
  "Yes": "Yes",
  "No": "No",
  "Other": "Other",
  "Send": "Send",
  "Edit": "Edit",
  "Delete": "Delete",
  "Save": "Save",
  "UsefulnessFeedbackReason": "Reason",
  "AnswerSnippet": "Answer to your question",
  "AnswerSpecificSnippet": "Answer to \"{0}\"",
  "SuggestedQuestions": "People also ask",
  "ExpandQuestionAnswer": "View answer for \"{0}\"",
  "MoreValuesAvailable": "additional values are available",
  "Breadcrumb": "Active filters",
  "OrganizationIsPaused": "Your Coveo organization is paused due to inactivity and search is currently unavailable.",
  "OrganizationWillResume": "Your organization is resuming and will be available shortly.",
  "UpdatingResults": "Updating results",
  "QuerySuggestionsAvailable": "{0} search suggestion<pl>s are</pl> available.",
  "QuerySuggestionsUnavailable": "There are no search suggestions.",
}
export function defaultLanguage() {
  var locales = String["locales"] || (String["locales"] = {});
  locales["en"] = merge(locales["en"], dict);
  String["toLocaleString"].call(this, { "en": dict });
  String["locale"] = "en";
  String["defaultLocale"] = "en";
  Globalize.culture("en")
}
export function setLanguageAfterPageLoaded() {
  var locales = String["locales"] || (String["locales"] = {});
  locales["en"] = merge(locales["en"], dict);
  String["toLocaleString"].call(this, { "en": dict });
  String["locale"] = "en";
  String["defaultLocale"] = "en";
  Globalize.culture("en")
}



// WEBPACK FOOTER //
// ./src/strings/DefaultLanguage.ts